import React, { Component } from "react";
import { connect } from "react-redux";
import MaterialTable from "@material-table/core";
import UpdateIcon from "@material-ui/icons/Update";
import ReplayIcon from "@material-ui/icons/Replay";
import TrendingFlatIcon from "@material-ui/icons/TrendingFlat";
import { withTranslation, Trans } from "react-i18next";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { sendMessage } from "../redux/actions/websocketActions";
import {
  setMessages,
  addMessage,
  updateMessage,
} from "../redux/actions/universalActions";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import axios from "../AxiosClient";
import { withSnackbar } from "notistack";

const styles = (theme) => ({
  messageContainer: {
    marginTop: 27,
    textAlign: "center",
  },
  messageIcon: {
    marginBottom: -7,
    marginLeft: 5,
    marginRight: 5,
  },
});
export class TranslationEditor extends Component {
  state = {
    deleteDialogOpen: false,
    resetAllDialogOpen: false,
    termToDelete: {},
  };

  render() {
    const { classes, t } = this.props;
    const columns = [
      {
        title: t("translation_editor_locale_header"),
        field: "locale",
        editable: "onAdd",
      },
      {
        title: t("translation_editor_key_header"),
        field: "key",
      },
      {
        title: t("global_message"),
        field: "message",
      },
      {
        title: "Global",
        field: "isGlobal",
        type: "boolean",
        initialEditValue: false,
      },
    ];

    return (
      <div
        style={{
          overflow: "auto",
          padding: 10,
          height: "100%",
          backgroundColor: "#eae0d7",
          backgroundImage: "url('../images/background.svg')",
        }}
      >
        <MaterialTable
          columns={columns}
          data={this.props.messages}
          editable={{
            onRowAdd: (newData) => {
              return new Promise((resolve) => {
                axios
                  .post(`/i18n/`, {
                    ...newData,
                    language: "en",
                    organization: this.props.currentUser.organization
                      .organizationId,
                  })
                  .then((res) => {
                    this.props.addMessage(res.data);
                    this.props.enqueueSnackbar(
                      this.props.t("new_message_created"),
                      {
                        variant: "success",
                      }
                    );
                  })
                  .catch((err) => {
                    this.props.enqueueSnackbar(
                      this.props.t("error_creating_new_message"),
                      {
                        variant: "error",
                      }
                    );
                  });
                resolve();
              });
            },
            onRowUpdate: (newData) => {
              return new Promise((resolve) => {
                axios
                  .patch(`/i18n/${newData.id}`, { ...newData })
                  .then((res) => {
                    this.props.updateMessage(res.data);
                    this.props.enqueueSnackbar(
                      this.props.t("message_successfully_updated"),
                      {
                        variant: "success",
                      }
                    );
                  })
                  .catch((err) => {
                    this.props.enqueueSnackbar(
                      this.props.t("error_updating_message"),
                      {
                        variant: "error",
                      }
                    );
                  });
                resolve();
              });
            },
          }}
          actions={[
            {
              icon: "replay",
              tooltip: t("translation_editor_default_tooltip"),
              onClick: (_e, rowData) => {
                this.resetToDefault(rowData);
              },
            },
            {
              id: "update-message",
              icon: "update",
              tooltip: t("translation_editor_previous_tooltip"),
              onClick: (_e, rowData) => {
                this.resetToPrevious(rowData);
              },
            },
            (rowData) => ({
              icon: "delete",
              tooltip: t("translation_editor_delete_tooltip"),
              disabled: rowData.userAdded === 0,
              onClick: (_e, rowData) => {
                this.setState({ termToDelete: rowData }, () =>
                  this.openDeleteDialog()
                );
              },
            }),
            {
              icon: "delete_sweep",
              tooltip: t("translation_editor_reset_all_button"),
              isFreeAction: true,
              onClick: () => {
                this.openResetAllDialog();
              },
            },
          ]}
          detailPanel={[
            {
              render: ({ rowData }) => {
                return (
                  <div>
                    <Tooltip
                      title={t("translation_editor_previous_tooltip")}
                      aria-label={t("translation_editor_previous_tooltip")}
                    >
                      <IconButton
                        id="secondary-reset-message-to-previous"
                        onClick={() => this.resetToPrevious(rowData)}
                      >
                        <UpdateIcon />
                      </IconButton>
                    </Tooltip>
                    <b>
                      <Trans i18nKey="translation_editor_previous_value_label" />
                    </b>{" "}
                    {rowData.previousMessage}
                    <br />
                    <Tooltip
                      title={t("translation_editor_default_tooltip")}
                      aria-label={t("translation_editor_default_tooltip")}
                    >
                      <IconButton
                        id="secondary-reset-message-to-default"
                        onClick={() => this.resetToDefault(rowData)}
                      >
                        <ReplayIcon />
                      </IconButton>
                    </Tooltip>
                    <b>
                      <Trans i18nKey="translation_editor_default_value_label" />
                    </b>{" "}
                    {rowData.defaultMessage}
                  </div>
                );
              },
            },
          ]}
          options={{
            pageSize: 10,
            pageSizeOptions: [5, 10, 15, 20],
            filtering: true,
          }}
          onRowClick={(_event, _rowData, togglePanel) => togglePanel()}
          title={t("global_translation_plural")}
        />

        <Dialog
          open={this.state.deleteDialogOpen}
          onClose={this.handleDeleteDialogClose}
          aria-labelledby="delete-dialog-title"
          aria-describedby="delete-dialog-description"
        >
          <DialogTitle id="delete-dialog-title">
            <Trans i18nKey="global_are_you_sure" />
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="delete-dialog-description">
              <Trans i18nKey="translation_editor_delete_message" />
            </DialogContentText>
            <div className={classes.messageContainer}>
              {this.state.termToDelete.key}{" "}
              <TrendingFlatIcon className={classes.messageIcon} />
              {this.state.termToDelete.message}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDeleteDialogClose} color="primary">
              <Trans i18nKey="global_cancel" />
            </Button>
            <Button
              id="delete-message"
              color="secondary"
              onClick={this.deleteConfirm}
            >
              <Trans i18nKey="global_delete" />
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.resetAllDialogOpen}
          onClose={this.handleResetAllDialogClose}
          aria-labelledby="reset-all-dialog-title"
          aria-describedby="reset-all-dialog-description"
        >
          <DialogTitle id="reset-all-dialog-title">
            <Trans i18nKey="global_are_you_sure" />
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="reset-all-dialog-description">
              <Trans i18nKey="translation_editor_reset_body" />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleResetAllDialogClose} color="primary">
              <Trans i18nKey="global_cancel" />
            </Button>
            <Button
              id="reset-all-messages"
              color="secondary"
              onClick={this.resetAllConfirm}
            >
              <Trans i18nKey="global_reset" />
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  openDeleteDialog = () => {
    this.setState({ deleteDialogOpen: true });
  };

  handleDeleteDialogClose = () => {
    this.setState({ deleteDialogOpen: false });
  };

  deleteConfirm = () => {
    axios
      .delete(`/i18n/${this.state.termToDelete.id}`)
      .then(() => {
        let messageClone = this.props.messages;
        messageClone = messageClone.filter(
          (m) => m.id !== this.state.termToDelete.id
        );
        this.props.setMessages(messageClone);
        this.handleDeleteDialogClose();
        this.props.enqueueSnackbar(
          this.props.t("message_successfully_deleted"),
          {
            variant: "success",
          }
        );
      })
      .catch((err) => {
        this.props.enqueueSnackbar(this.props.t("error_deleting_message"), {
          variant: "error",
        });
      });
  };

  openResetAllDialog = () => {
    this.setState({ resetAllDialogOpen: true });
  };

  handleResetAllDialogClose = () => {
    this.setState({ resetAllDialogOpen: false });
  };

  resetAllConfirm = () => {
    axios
      .post(`/i18n/reset`)
      .then(() => {
        this.handleResetAllDialogClose();
        this.props.enqueueSnackbar(
          this.props.t("all_messages_successfully_reset"),
          {
            variant: "success",
          }
        );
      })
      .catch((err) => {
        this.props.enqueueSnackbar(
          this.props.t("error_reseting_all_messages"),
          {
            variant: "error",
          }
        );
      });
  };

  resetToDefault = (row) => {
    axios
      .post(`/i18n/${row.id}/default`)
      .then((res) => {
        this.props.updateMessage(res.data);
        this.props.enqueueSnackbar(
          this.props.t("message_successfully_reset_to_default"),
          {
            variant: "success",
          }
        );
      })
      .catch((err) => {
        this.props.enqueueSnackbar(
          this.props.t("error_reseting_message_to_default"),
          {
            variant: "error",
          }
        );
      });
  };

  resetToPrevious = (row) => {
    axios
      .post(`/i18n/${row.id}/previous`)
      .then((res) => {
        this.props.updateMessage(res.data);
        this.props.enqueueSnackbar(
          this.props.t("message_successfully_reset_to_previous_value"),
          {
            variant: "success",
          }
        );
      })
      .catch((err) => {
        this.props.enqueueSnackbar(
          this.props.t("error_setting_message_to_previous_value"),
          {
            variant: "error",
          }
        );
      });
  };
}

const mapStateToProps = (state) => ({
  messages: state.setting.messages,
  message: state.websocket.message,
  language: state.user.language,
  currentUser: state.user.currentUser,
});

const mapDispatchToProps = {
  sendMessage,
  setMessages,
  addMessage,
  updateMessage,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withSnackbar(withStyles(styles)(TranslationEditor))));
